/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs */

const en_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chosen by thousands in our community,
this champion tree is now yours to bring home to your forest.`)
};

const ar_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مختار من قبل الآلاف في مجتمعنا،
أصبحت هذه الشجرة البطل لك الان لتأخذها إلى غابتك.`)
};

const de_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Champion-Baum wurde von Tausenden in unserer Gemeinde ausgewählt und kann nun von Ihnen in Ihren Wald gebracht werden.`)
};

const es_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegido por miles de personas de nuestra comunidad, este árbol campeón ahora es tuyo para que lo lleves a tu bosque.`)
};

const fr_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisi par des milliers de membres de notre communauté, cet arbre champion est désormais le vôtre.`)
};

const it_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scelto da migliaia di persone nella nostra community,
questo albero campione è ora tuo e puoi portarlo nella tua foresta.`)
};

const ja_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティで何千人ものユーザーに選ばれた人気の木が、
森に仲間入りします。`)
};

const ko_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest 커뮤니티에서 수천 명이 선택한
이 챔피언 나무를 이제 자신의 숲으로 가져갈 수 있어요.`)
};

const pt_br_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhida por milhares em nossa comunidade,
esta planta vencedora agora pertence a você, para levá-la à sua floresta.`)
};

const ru_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это дерево-чемпион, выбранное тысячами членов нашего сообщества, теперь ваше — заберите его домой, в свой лес.`)
};

const th_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้แห่งชัยชนะที่สมาชิกหลายพันในชุมชนของเราได้เลือกสรร
ตอนนี้พร้อมให้คุณนำกลับไปปลูกในป่าของคุณแล้ว`)
};

const tr_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplumumuzdaki binlerce kişi tarafından seçilen bu şampiyon ağaç, 
artık ormanına götürmen için hazır.`)
};

const zh_cn_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这棵由数千位社群用户票选出的冠军树，
现在，由你亲手带回森林。`)
};

const zh_tw_pro_user_appreciation_letter_bald_cypress_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這棵由數千位社群用戶票選出的冠軍樹，
現在，由你親手帶回森林。`)
};

/**
* | output |
* | --- |
* | "Chosen by thousands in our community, this champion tree is now yours to bring home to your forest." |
*
* @param {Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_bald_cypress_body3 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Bald_Cypress_Body3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_bald_cypress_body3(inputs)
	return zh_tw_pro_user_appreciation_letter_bald_cypress_body3(inputs)
});